module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalConfirmation', {
    attrs: {
      "isShowConfirmDeleteMessage": false,
      "customWidth": "460px",
      "ariaLabel": _vm.i18n.title
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('h3', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_vm._v(_vm._s(_vm.i18n.title))]), _vm._v(" "), _c('template', {
    slot: "custom_warning"
  }, [_c('p', {
    staticClass: "spuc__intro"
  }, [_vm._v(_vm._s(_vm.introText))]), _vm._v(" "), _c('table', {
    staticClass: "spuc__table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.i18n.calendar))]), _vm._v(" "), _c('th', {
    staticClass: "spuc__num"
  }, [_vm._v(_vm._s(_vm.i18n.current))]), _vm._v(" "), _c('th', {
    staticClass: "spuc__num"
  }, [_vm._v(_vm._s(_vm.i18n.new))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.poolRows), function(row) {
    return _c('tr', {
      key: row.calendarId
    }, [_c('td', [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
      staticClass: "spuc__num spuc__old"
    }, [_vm._v(_vm._s(row.hours))]), _vm._v(" "), _c('td', {
      staticClass: "spuc__num spuc__newval"
    }, [_vm._v(_vm._s(_vm.formattedNewHours))])])
  }), 0)])]), _vm._v(" "), _c('template', {
    slot: "confirm_buttons"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('subjectOnly')
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n.only_subject))]), _vm._v(" "), _c('button', {
    staticClass: "bttn bttn--submit",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onUpdateAll.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n.update_all))])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b0b59bca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subjects/SubjectPoolsUpdateConfirm.vue
// module id = 2093
// module chunks = 1